// extracted by mini-css-extract-plugin
export var active = "_d7-2";
export var recordingDot = "_d7-1";
export var recordingIndicator = "_d7-0";